export default __webpack_public_path__ + "static/media/todo.854a0769.svg";